module.exports = __webpack_public_path__ + "static/ourwork-conferences-7c25e63598e2e6dcf7c0607d5115e95e.jpg";